import React from "react";
import { Link } from "react-router-dom";

import { AuthCard } from "../../../common/u1/AuthCard";
import { AuthHeader } from "../../../common/u1/AuthHeader";
import { Input } from "../../../common/u1/Input";
import { Button } from "../../../common/u1/Button";
import { ErrorNote } from "../../../common/u1/ErrorNote";
import { useForgotEmail } from "./useForgotEmail";
import { ArrowRight } from "../../../../assets/ui/icons";

/* Step 1 — ask for the address. */
export const EmailStep = ({ onNext, onLinkedToken, email: initialEmail = "" }) => {
  const { email, setEmail, error, isLoading, handleSubmit } = useForgotEmail({
    onNext,
    onLinkedToken,
    initialEmail,
  });

  return (
    <AuthCard>
      <form onSubmit={handleSubmit} className="w-full">
        <AuthHeader
          title="Reset your password"
          subtitle="Enter the email address you'd like your password reset instructions sent to."
        />

        <div className="mt-7">
          <Input
            id="email"
            name="email"
            type="email"
            size="lg"
            label="Email"
            autoComplete="email"
            placeholder="you@company.com"
            value={email || ""}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        {error && <ErrorNote>{error}</ErrorNote>}

        <Button
          type="submit"
          variant="primary"
          size="lg"
          className="mt-5 w-full"
          disabled={isLoading}
        >
          {isLoading ? "Sending…" : "Reset your password"}
        </Button>

        <div className="mt-5 text-center">
          <Link
            to="/login"
            className="inline-flex items-center gap-1.5 text-[12.5px] font-semibold text-[var(--ink-2)] hover:text-[var(--ink)] font-sans"
          >
            {/* No dedicated left arrow in the shared set; the right one
                rotated is the same mark, the convention EditFooterBar already
                uses for its Go Back chevron. */}
            <ArrowRight size={14} className="rotate-180" /> Back to log in
          </Link>
        </div>
      </form>
    </AuthCard>
  );
};

export default EmailStep;
